// Canonical ids rendered by <CustomActivityV2> (see blockToComponent.jsx).
const CUSTOM_ACTIVITY_V2_IDS = new Set(['custom_activity_v2', 'custom_activity_slides_v2']);

/**
 * True when sections hold nothing to render: none at all, or only page breaks.
 *
 * @param {Array<{type: string}> | undefined} sections
 * @returns {boolean}
 */
const hasNoContent = (sections) => !sections?.some((section) => section?.type !== 'page_break');

/**
 * True for a CustomActivityV2 block with nothing to render. Such an activity is treated as
 * deleted: it paginates to zero pages, and PagesWithSections reads zero pages as "still
 * measuring", so it would show its "Loading..." page (and hold up every capture) forever.
 *
 * Generation never produces one (the backend validator rejects EMPTY_SECTIONS, and a block that
 * is still generating is a separate `canonical_id: 'loading'` block). It comes from a teacher
 * deleting every section.
 *
 * @param {object} block
 * @returns {boolean}
 */
export const isEmptyCustomActivity = (block) =>
  CUSTOM_ACTIVITY_V2_IDS.has(block?.canonical_id) &&
  hasNoContent(block?.resource_data?.custom_content?.items?.[0]?.structure?.sections);
